<script setup lang="ts">
import type { SpecialItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SpecialItemProps>(), { fromname: null })

const app = useNuxtApp()
const storeIndex = useStoreIndex()

const linkTo = computed(() => {
  if (props.fromname) {
    return {
      path: `/special/${props.item.article_slug}`,
      query: { fromname: props.fromname },
    }
  } else {
    return `/special/${props.item.article_slug}`
  }
})
</script>

<template>
  <div
    class="c-specialItem"
  >
    <div class="c-specialItem_header">
      <div class="c-specialItem_header_info">
        <nuxt-link
          class="c-specialItem_header_info_title c-clampLines is-clampline2"
          v-bind:to="linkTo"
        >
          {{ item.title }}
        </nuxt-link>
      </div>
    </div>
    <div class="c-specialItem_info">
      <div class="c-specialItem_info_imageBox">
        <nuxt-link
          class="u-hoverZoom"
          v-bind:to="linkTo"
        >
          <CommonImage
            v-bind:src="storeIndex.getArticleEyeCatchImageURL(item.eye_catch_image_object)"
            error-src="/images/noimage.svg"
            v-bind:alt="item.title"
            object-fit="cover"
            is-hover-effect
          />
        </nuxt-link>
      </div>
      <div class="c-specialItem_info_detailBox">
        <div class="c-specialItem_info_detailBox_detail">
          <div
            v-if="item.custom && item.custom.excerpt"
            class="c-specialItem_info_detailBox_detail_text c-clampLines is-clampline6"
            v-html="app.$trimEnter(item.custom.excerpt)"
          />
        </div>
        <div
          class="c-specialItem_info_detailBox_link"
        >
          <ArrowLink
            v-bind:to="linkTo"
            label="特集記事を読む"
            bold
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-specialItem {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 40px;
  padding: 20px;
  background-color: var(--color_background_whiteblue);
  color: var(--color_text_base);
  font-family: var(--g_font_family_NotoSansCJKjp);

  @include responsive.mq_down(sp) {
    display: block;
    padding: 15px;
  }

  &_header {
    display: flex;

    &_info {
      display: flex;
      flex-direction: column;

      @include responsive.mq_down(sp) {
        display: block;
      }

      &_title {
        margin-top: -5px !important;
        color: var(--color_text_base);
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 20px;
        font-weight: bold;
        letter-spacing: -0.2px;

        @include responsive.mq_down(sp) {
          font-size: 18px;
        }
      }

      &_date {
        margin-top: 3px;
        color: var(--g_color_text_888888);
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 14px;
      }
    }
  }

  &_info {
    display: flex;
    margin-top: 25px;

    @include responsive.mq_down(sp) {
      display: block;
      margin-top: 16px;
    }

    &_imageBox {
      flex-shrink: 0;
      width: 200px;

      @include responsive.mq_down(sp) {
        width: 100%;
      }
      :deep(.extended-image) {
        width: 200px;
        height: 150px;
      }
    }

    &_detailBox {
      flex-grow: 1;
      margin-left: 30px;
      font-family: var(--g_font_family_NotoSansCJKjp);

      @include responsive.mq_down(sp) {
        margin: 20px 0 0;
      }

      &_detail {
        min-height: 150px;

        @include responsive.mq_down(sp) {
          min-height: initial;
        }

        &_text {
          // min-height: 104px;
          color: var(--color_text_base);
          font-size: 14px;
          line-height: 1.8;

          // @include responsive.mq_down(sp) {
          //   min-height: initial;
          // }
        }
      }

      &_link {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
      }

      &_category {
        margin-top: 20px;
        color: var(--color_text_base);
        font-size: 14px;
      }
    }
  }
}
</style>
